export default __webpack_public_path__ + "static/media/mobile_deckcustomize.e8184a58.webp";